import React, { useContext } from 'react';
import { ContentBox, Item } from '../ContentBox/ContentBox';
import { useGetLoanDocByLoan } from 'services/loan/querys';
import { TaskOpenModalContext } from 'scenes/Private/Private';
import { TaskState } from 'gql/graphql';

interface IProps {
  loanSelected: any;
}

export const BoxLoanDocuments: React.FC<IProps> = ({ loanSelected }: IProps) => {

  const { setHandler: openTask }: any = useContext(TaskOpenModalContext);

  const { data: loanDocs } = useGetLoanDocByLoan({ 
    variables: { loanId: loanSelected._id },
  });
  
  const termSheet = loanDocs?.find((doc: any) => doc.key === 'term_sheet' && !doc.hidden);
  const appraisal = loanDocs?.find((doc: any) => doc.key === 'appraisal' && !doc.hidden);
  const showTermSheet = !termSheet || (!termSheet.isDeleted && !termSheet.hidden);
  const showAppraisal = !appraisal || (!appraisal.isDeleted && !appraisal.hidden);
  const closingDocs = loanDocs?.find((doc: any) => doc.key === 'closing_docs' && !doc.hidden);
  const otherDocuments = loanDocs?.filter((doc: any) => doc.key !== 'term_sheet' && doc.key !== 'appraisal' && doc.key !== 'closing_docs' && !doc.hidden) ?? [];

  const isAppraisalDocState = loanDocs?.find(item => item.key === 'appraisal')
  let appraisalState = isAppraisalDocState ? 'Ordered' : 'Not Ordered';

  const isDisabledAppraisal = isAppraisalDocState && ((isAppraisalDocState?.state as any) !== TaskState.Approved);
  //Download
  const isApprovedAppraisal = (isAppraisalDocState?.state as any) === TaskState.Approved;
  if (isApprovedAppraisal) appraisalState = '';

  const actionAppraisal = () => {
    if(isApprovedAppraisal && isAppraisalDocState?.file) {
      window.open(isAppraisalDocState?.file?.url, '_blank');
      return;
    }

    if(!isDisabledAppraisal){
      openTask('pay_appraisal')
      return;
    }
  }
  
  const loanDocumentsContent: Item[] = [
    ...(showTermSheet
      ? [{ field: 'Term sheet', value: <span onClick={() => window.open(loanSelected.onboarding.termSheetURL, '_blank')}>{"Download ->"}</span> }]
      : []),
      
    ...otherDocuments.map((doc: any) => ({
      field: doc.name,
      value: <span onClick={() => window.open(doc?.file?.url, '_blank')}>{"Download ->"}</span>
    })),

    { field: 'Pre-approval letter', value: <span onClick={() => window.open(loanSelected.onboarding.preApprovalLetterUrl, '_blank')}>{"Download ->"}</span> },

    ...(showAppraisal
      ? [{
        field: 'Appraisal',
        state: appraisalState,
        value: <span
          aria-disabled={isDisabledAppraisal}
          className={isDisabledAppraisal ? 'disabled' : ''}
          style={{ opacity: isDisabledAppraisal ? 0.3 : 1 }}
          onClick={actionAppraisal}>
          {isApprovedAppraisal? "Download ->": "Pay appraisal ->"}
        </span>
      }]
      : []),
    ...(closingDocs
      ? closingDocs.file
        ? [
            { field: 'Closing documents', value: <span onClick={() => window.open(closingDocs?.file?.url, '_blank')}>{"Download  document 1 ->"}</span> },
          ]
        : closingDocs.files && closingDocs.files.length > 0 ? (closingDocs?.files?.map((file: any, index: number) => ({
            field: 'Closing documents',
            value: <span onClick={() => window.open(file?.url, '_blank')}>{`Download document ${index + 1} ->`}</span>,
          })) ?? [{ field: 'Closing documents', value: <i>Available after closing</i> }])
      : [{ field: 'Closing documents', value: <i>Available after closing</i> }] : []
    )
  ];

  return (
    <ContentBox
      label={'Loan documents'}
      content={loanDocumentsContent}
    />
  );
}